/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid, DialogContentText, Link, Typography } from '@material-ui/core';
import { CheckCircleOutline, NotInterested } from '@material-ui/icons';
import { Table, DefaultFiltro, DialogDefault } from '../../components';
import * as selectorsAuth from '../../store/auth/reducer';
import * as selectorsFolhaPonto from '../../store/folhaPonto/reducer';
import * as actionsFolhaPonto from '../../store/folhaPonto/actions';
import Formulario from './Formulario';
import * as Roles from '../../constants/role';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const Convocacao = ({ folhaPontos, folhaPontoReport, downloadFolhaPontoById, authData, folhaPontoUpdateStatus, deleteFolhaPonto }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({
    inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
    fim: moment().add(1, 'month').endOf('month').valueOf()
  });
  const [reload, setReload] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [openValidate, setOpenValidate] = useState(false);
  const [validateData, setValidateData] = useState({});

  const classes = useStyles();
  
  const renderDocumentCell = folhaPonto => (
    <TableCell>
        <Link href="#" onClick={() => {
          downloadFolhaPontoById(folhaPonto.id, "EMPTY");
        }}>Documento em branco</Link>
        {folhaPonto.filled && <>
          <br />
          <Link href="#" onClick={() => {
            downloadFolhaPontoById(folhaPonto.id, "FILLED");
          }}>Documento preenchido</Link>
        </>}
    </TableCell>
  )

  const renderRows = d => {
    return (
      <>
        <TableCell>{d.dataInicioValue} a {d.dataFimValue}</TableCell>
        <TableCell>{d.usuarioNome}</TableCell>
        <TableCell>{d.regimeTrabalhoName}</TableCell>
        <TableCell>{d.statusDescricao}</TableCell>
        {renderDocumentCell(d)}
        <TableCell>Criado por {d.criadoPorNome}<br/> em {d.dataCriacaoValue}</TableCell>
      </>
    )
  }

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = () => {
    setOpen(false);
    setId(null);
    setReload(!reload);
  }

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const getHeaderActions = () => {
    let actions = [];

    if (isAdmin()) {
      actions.push({ 
        title: 'Relatório',
        onClick: () => setOpenExport(true)
      });
    }

    return actions;
  }

  const onDelete = (id, callback) => deleteFolhaPonto(id, callback);

  return (
    <Grid container>
      <Grid item xs={12}>
        <DefaultFiltro 
          onFilter={filterData => setLocalFilter(filterData)}
          useDates
          useInspetor
          xsInspetor="6"
          mdInspetor="6"
          labelInspetor="Usuários"
          useInspetorMultiSelect
          useFolhaPontoStatus
          useRegimeTrabalho
          reload={!reload}
          getDefaultDates={() => ({
            inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
            fim: moment().add(1, 'month').endOf('month').valueOf()
          })}
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={folhaPontos}
          titles={['Período', 'Usuário', 'Regime Trabalho', 'Status', 'Documentos', 'Informações']}
          headerTitle="Folhas de Ponto"
          renderRows={renderRows}
          hasRowActions
          onEdit={onEdit}
          onAdd={onAdd}
          hasAdd={isAdmin()}
          headerActions={getHeaderActions()}
          showDelete={process.env.REACT_APP_USUARIO_CAN_DELETE_FOLHA_PONTO.split(',').includes(authData.email)}
          onDelete={onDelete}
          usePaginationApi
          paginationApi="folha-pontos/filter"
          paginationUrl="folha-pontos"
          filterData={localFilter}
          reload={!reload}
          actions={
            [
              {
                key: 'validate',
                icon: <CheckCircleOutline />,
                show: row => isAdmin() && row.status === 'RECEIVED',
                onClick: id => {
                  setValidateData({ id, status: 'VALIDATED', message: "Deseja validar a folha de ponto?" });
                  setOpenValidate(true);
                }
              },
              {
                key: 'invalidate',
                icon: <NotInterested />,
                show: row => isAdmin() && row.status === 'RECEIVED',
                onClick: id => {
                  setValidateData({ id, status: 'NOT_VALID', message: "Deseja invalidar a folha de ponto?" });
                  setOpenValidate(true);
                }
              },
            ]
          }
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          folhaPontos={folhaPontos}
          onReload={() => setReload(!reload)}
        />
        <DialogDefault
          open={openExport}
          useFullScreen={false}
          handlerCancel={() => setOpenExport(false)}
          handlerConfirm={() => {
            folhaPontoReport(localFilter, () => {
              setOpenExport(false);
            });
          }}
          title="Confirmação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText> Deseja baixar todas as informações filtradas? </DialogContentText>
        </DialogDefault>
        <DialogDefault
          open={openValidate}
          handlerCancel={() => {
            setValidateData({});
            setOpenValidate(false);
          }}
          handlerConfirm={() => {
            folhaPontoUpdateStatus(validateData, () => setReload(!reload));
            setOpenValidate(false);
          }}
          title="Confimação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText> 
            <Grid>
              <Typography variant="h4">
                {validateData.message}
              </Typography>
            </Grid>
          </DialogContentText>
        </DialogDefault>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  folhaPontos: selectorsFolhaPonto.getFolhaPontos(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsFolhaPonto
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Convocacao));